import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import checkedImage from "../../../../../../../../assets/checkedbox.png";
import unCheckedImage from "../../../../../../../../assets/uncheckedBox.png";

import correct from "../../../../../../../../assets/correct.png";
import wrong from "../../../../../../../../assets/wrong.png";
import {
  getWeekAssessment,
  getWeekContentExcludingVideos,
  getWeekPreAssessment,
} from "../../../data/index.js";
import { useQuery } from "@tanstack/react-query";
import userService from "../../../../../../../../services/api/user.js";
import adminService from "../../../../../../../../services/api/admin.js";
import { calculateResult } from "../../../utility.js";
import { adminData } from "../../../../../../../../redux/reducers/adminReducer.js";
import Modal from "../../components/Modal.jsx";
import { useMutation } from "@tanstack/react-query";
import { useSelector } from "react-redux";

function Week2({ enrollmentId, setWeekTwoData }) {
  const { pages } = getWeekContentExcludingVideos(2);

  const activity1 = pages.find((page) => page.id === 2);
  const activity2 = pages.find((page) => page.id === 6);
  const activity3 = pages.find((page) => page.id === 8);
  const activity4 = pages.find((page) => page.id === 10);
  const activity5 = pages.find((page) => page.id === 12);
  const activity7 = pages.find((page) => page.id === 14);
  const activity8 = pages.find((page) => page.id === 16);
  // const [q1, q2, q3, q4] = activity3.prompts;
  const [activityData, setActivityData] = useState([]);
  const [assessmentData, setAssessmentData] = useState([]);
  const [preAssessmentData, setPreAssessmentData] = useState([]);

  const { questions: preAssessments } = getWeekPreAssessment(2);

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState("");
  const [activityFeedbackId, setActivityFeedbackId] = useState(null);

  const { isAdmin, code } = useSelector(adminData);

  const { questions: assessments } = getWeekAssessment(2);

  // toDo: Fetch User assessment and Activity Data
  const { data, isPending, status, isError } = useQuery({
    queryKey: ["dashboard/tot-feedback-2", enrollmentId, 2],

    queryFn: () =>
      isAdmin
        ? adminService.getUserCourseData(enrollmentId, 2, code)
        : userService.getUserCourseData(enrollmentId, 2),
    enabled: !!enrollmentId,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    keepPreviousData: false,
  });

  const mutation = useMutation({
    mutationFn: () =>
      adminService.submitAdminFeedback(
        activityData,
        enrollmentId,
        2,
        data?.activity?.user,
        code
      ),
    onSuccess: (data) => {
      setModalData("");
      // setIsOpen(true)
      // toast.success(data.message)
    },
    onError: (error) => {
      console.error("Registration error:", error);
      setModalData("");
      // toast.dismiss()
      // toast.error(error?.message)
      // navigate('/sign-in', { replace: true })
    },
  });

  const handleModalOpen = () => {
    setShowModal(true);
  };

  const handleModalClose = () => {
    setActivityFeedbackId(null);
    setShowModal(false);
  };

  useEffect(() => {
    if (!data) return;

    const activities = Array.isArray(data.activity?.activities)
      ? data.activity.activities
      : [];

    setActivityData(activities);
    setAssessmentData(
      Array.isArray(data.assessment?.assessments)
        ? data.assessment.assessments
        : [],
    );
    setPreAssessmentData(
      activities.find((p) => Number(p.page) === 4)?.answer || [],
    );
    setWeekTwoData(true);

    return () => { };
  }, [data]);

  function getActivityAnswer(activityId, itemId) {
    if (!itemId) {
      return activityData?.find((activity) => activity.page === activityId)
        ?.answer;
    } else {
      const answersList = activityData?.find(
        (activity) => activity.page === activityId
      )?.answer;

      const answerObject = answersList?.find(
        (activity) => activity.id === itemId
      )?.value;
      return answerObject ? answerObject : "";
    }
  }

  const renderAnswerText = (answer) => {
    if (answer == null) return "";
    if (typeof answer === "string" || typeof answer === "number")
      return String(answer);
    if (Array.isArray(answer)) {
      return answer
        .map((item) => renderAnswerText(item))
        .filter(Boolean)
        .join(", ");
    }
    if (typeof answer === "object") {
      if ("value" in answer) return renderAnswerText(answer.value);
      if ("answer" in answer) return renderAnswerText(answer.answer);
      return "";
    }
    return "";
  };

  function getActivityFeedback(activityId, itemId, index) {
    if (!itemId) {
      return activityData?.find((activity) => activity.page === activityId)
        ?.feedback;
    } else {
      const answersList = activityData?.find(
        (activity) => activity.page === activityId
      )?.feedback;

      const answerObject = answersList?.find(
        (activity) => activity.stepId === itemId
      )?.value;

      // return answerObject ? answerObject[index] : null;
      return answerObject ? answerObject : null;
    }
  }

  function def(type) {
    if (!activityData || !activityData[1] || !activityData[1].answer) return [];

    const data =
      type === "question"
        ? activity2.steps
          .filter((item) => item.type === "dropdownScenario")
          .map((item) => item.question)
        : activityData[1].answer.map((item) => item.value);

    return data;

    // const items = indices?.map((index) => activity2?.images[index]) || [];

    // // Sort with featured names first
    // return items.sort((a, b) => {
    //   const aFeatured = featuredNames.includes(a);
    //   const bFeatured = featuredNames.includes(b);
    //   if (aFeatured && !bFeatured) return -1;
    //   if (!aFeatured && bFeatured) return 1;
    //   return 0;
    // });
  }

  function drag1(type) {
    console.log(activityData, "Activity Data");
    const activityAnswer = activityData?.find(
      (activity) => activity.page === activity2.id
    )?.answer;
    if (!Array.isArray(activityAnswer)) return [];

    const indices =
      type === "mild"
        ? activityAnswer?.[0]?.value?.green
        : type === "frustrate"
          ? activityAnswer?.[0]?.value?.orange
          : activityAnswer?.[0]?.value?.red;

    // console.log(indices, "Indices")

    // console.log(activity2,"Activity 2")
    return indices?.map((index) => activity2?.steps?.[1].images[index]) || [];
  }

  function getRankingResponses(rankings, rankingStep) {
    if (!rankings || typeof rankings !== "object") return [];

    return Object.keys(rankings)
      .sort((a, b) => Number(a) - Number(b))
      .map((key) => {
        const responseId = rankings[key];
        const response = rankingStep?.responses?.find(
          (item) => item.id === responseId
        );
        return response?.text || responseId;
      })
      .filter(Boolean);
  }

  if (isPending) {
    return <div>Loading...</div>;
  }

  if (data?.status === "failed" || isError) {
    return <div>{data?.message}</div>;
  }

  const score =
    calculateResult(assessments, assessmentData, assessments?.length) || 0;

  const submitFeedback = (value) => {
    if (!activityFeedbackId?.itemId) {
      const answerData = activityData.find(
        (item) => item.page === activityFeedbackId.activityId
      );
      answerData.feedback = value;
      handleModalClose();
      mutation.mutate();
    } else {
      const answerData = activityData.find(
        (item) => item.page === activityFeedbackId.activityId
      );
      const feedback = Array.isArray(answerData.feedback)
        ? [...answerData.feedback]
        : [];
      const existing = feedback.find(
        (item) => Number(item?.stepId) === Number(activityFeedbackId.itemId)
      );
      if (existing) existing.value = value;
      else feedback.push({ stepId: activityFeedbackId.itemId, value });
      answerData.feedback = feedback;

      handleModalClose();
      mutation.mutate();
    }
  };

  return (
    <>
      {/* Activity 1 */}
      <p className="bg-blue py-md-3 px-md-5 py-1 px-2 text-white d-inline-block rounded-5 fs-md-4">
        Activity 1
      </p>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Questions:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          style={{ fontSize: 1 + "em" }}
        >
          {activity1.question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {renderAnswerText(getActivityAnswer(activity1.id))}
        </p>
        {isAdmin &&
          !activityData?.find((activity) => activity.page === activity1.id)
            ?.feedback && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity1.id });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        activityData?.find((activity) => activity.page === activity1.id)
          ?.feedback && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity1.id)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity1.id));
                  setActivityFeedbackId({ activityId: activity1.id });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      {/* PreAssesment 1 */}
      <p className="bg-blue py-1 px-1 py-md-3 px-md-2 text-white d-inline-block rounded-5 fs-md-4">
        Pre-Assessment
      </p>
      <hr />
      {(preAssessments || []).map(({ id, question, options = [], correctOption }, i) => {
        // todo:  fetch preassesment data from backend and switch
        const selectedAnswer = Array.isArray(preAssessmentData)
          ? preAssessmentData.find((answer) => answer.id === id)?.value
          : undefined;
        return (
          <>
            <div className="d-flex gap-3" key={i}>
              <p
                className="text-blue fs-md-1 text-nowrap week-2-question-text fw-bold"
                style={{ fontSize: 1 + "em" }}
              >
                Questions {i + 1}:
              </p>
              <p
                className="text-blue fs-md-4 week-2-question-text"
                style={{ fontSize: 1 + "em" }}
              >
                {question}
              </p>
            </div>
            {(options || []).map((option, index) => {
              const optionKey = Object.keys(option)[0];
              const optionText = option[optionKey];
              const isCorrectOption = correctOption === optionText;
              const isAnswer = selectedAnswer === optionText;
              // console.log(assessmentData,"AssessmentData")

              return (
                <div
                  key={index}
                  className="d-flex gap-md-2 p-0 p-md-1 mb-3 justify-content-between"
                >
                  <div className="d-flex gap-md-2 p-1">
                    <img
                      src={isAnswer ? checkedImage : unCheckedImage}
                      alt={`Option ${optionKey}`}
                      style={{ width: 20, height: 20 }}
                    />
                    <div
                      className="week-2-question-text text-gray"
                      style={{ fontSize: 1 + "em" }}
                    >{`${optionText}. ${option.text}`}</div>
                  </div>
                  {isCorrectOption ? (
                    <p className="d-flex gap-1">
                      {" "}
                      <img
                        src={correct}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />{" "}
                      Correct
                    </p>
                  ) : (
                    <p className="d-flex gap-1">
                      {" "}
                      <img
                        src={wrong}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />
                      Wrong
                    </p>
                  )}
                </div>
              );
            })}
          </>
        );
      })}
      <hr />
      {/* Activity 2 */}
      <p className="bg-blue py-md-3 px-md-5 py-1 px-2 text-white d-inline-block rounded-5 fs-md-4">
        Activity 2
      </p>
      <p
        className="text-gray fs-md-4 week-2-question-text"
        accordion
        style={{ fontSize: 1 + "em" }}
      >
        {activity2.steps[0].challenge} <br />
        <span className="fw-bold text-gray">
          {activity2.steps[0].statement}
        </span>
      </p>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Questions:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity2.steps[1].instruction}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <div className="flex-grow-1 d-flex">
          <div className="flex-grow-1">
            <p
              className="text-center bg-green text-white py-md-3 py-1 fs-md-1 week-2-question-text"
              style={{ fontSize: 1 + "em" }}
            >
              MILD
            </p>
            <div className="px-2 py-1 px-md-5 py-md-3">
              {drag1("mild")?.map((item, idx) => (
                <p className="fs-md-4">
                  {idx + 1}. {renderAnswerText(item)}
                </p>
              ))}
            </div>
          </div>
          <div className="flex-grow-1">
            <p
              className="text-center bg-orange text-white py-md-3 py-1 fs-md-1 week-2-question-text"
              style={{ fontSize: 1 + "em" }}
            >
              FRUSTRATE
            </p>
            <div className="px-2 py-1 px-md-5 py-md-3">
              {drag1("frustrate")?.map((item, idx) => (
                <p className="fs-md-4">
                  {idx + 1}. {renderAnswerText(item)}
                </p>
              ))}
            </div>
          </div>
          <div className="flex-grow-1">
            <p
              className="bg-red text-center text-white py-md-3 py-1 fs-md-1 week-2-question-text"
              style={{ fontSize: 1 + "em" }}
            >
              HIGH
            </p>
            <div className="px-2 py-1 px-md-5 py-md-3">
              {drag1("high")?.map((item, idx) => (
                <p className="fs-md-4">
                  {idx + 1}. {renderAnswerText(item)}
                </p>
              ))}
            </div>
          </div>
        </div>

        {
          //This is only Visible for Flow Admins
          isAdmin &&
          !activityData?.find((activity) => activity.page === activity2.id)
            ?.feedback && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity2.id });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )
        }
      </div>
      {
        // Show this only id theres a feedback
        activityData?.find((activity) => activity.page === activity2.id)
          ?.feedback && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-1 p-md-2 rounded">
              {getActivityFeedback(activity2.id)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity2.id));
                  setActivityFeedbackId({ activityId: activity2.id });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />

      {/* Activity 3 */}
      <p className="bg-blue py-md-3 px-md-5 py-1 px-2 text-white d-inline-block rounded-5 fs-md-4">
        Activity 3
      </p>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Questions:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          style={{ fontSize: 1 + "em" }}
        >
          {activity3.question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {renderAnswerText(getActivityAnswer(activity3.id))}
        </p>
        {isAdmin &&
          !activityData?.find((activity) => activity.page === activity3.id)
            ?.feedback && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity3.id });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        activityData?.find((activity) => activity.page === activity3.id)
          ?.feedback && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity3.id)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity3.id));
                  setActivityFeedbackId({ activityId: activity3.id });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />

      {/* Activity 4 */}
      <p className="bg-blue py-md-3 px-md-5 py-1 px-2 text-white d-inline-block rounded-5 fs-md-4">
        Activity 4
      </p>
      <p
        className="text-gray fs-md-4 week-2-question-text"
        accordion
        style={{ fontSize: 1 + "em" }}
      >
        {activity7.steps[0].instruction}
      </p>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 1:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity7.steps[1].scenarioTitle}
        </p>
      </div>
      <p
        className="text-white rounded-3 px-2"
        style={{ background: activity7.steps[1].sonarSteps[0].desBgColor }}
      >
        {activity7.steps[1].sonarSteps[0].stepName}{" "}
        {activity7.steps[1].sonarSteps[0].stepDescription}:{" "}
        {activity7.steps[1].sonarSteps[0].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const activity = getActivityAnswer(activity7.id);
            if (!activity || !activity.scenario_1 || !activity.scenario_1.sonar)
              return "";
            return activity.scenario_1.sonar["1"] || "";
          })()}
        </p>

        {isAdmin &&
          !getActivityFeedback(activity7.id, 1) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity7.id, itemId: 1 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity7.id, 1) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity7.id, 1)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity7.id, 1));
                  setActivityFeedbackId({ activityId: activity7.id, itemId: 1 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <p
        className="text-white rounded-3 px-2"
        style={{ background: activity7.steps[1].sonarSteps[1].desBgColor }}
      >
        {activity7.steps[1].sonarSteps[1].stepName}{" "}
        {activity7.steps[1].sonarSteps[1].stepDescription}:{" "}
        {activity7.steps[1].sonarSteps[1].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const activity = getActivityAnswer(activity7.id);
            if (!activity || !activity.scenario_1 || !activity.scenario_1.sonar)
              return "";
            return activity.scenario_1.sonar["2"] || "";
          })()}
        </p>

        {isAdmin &&
          !getActivityFeedback(activity7.id, 2) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity7.id, itemId: 2 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity7.id, 2) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity7.id, 2)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity7.id, 2));
                  setActivityFeedbackId({ activityId: activity7.id, itemId: 2 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <p
        className="text-white rounded-3 px-2"
        style={{ background: activity7.steps[1].sonarSteps[2].desBgColor }}
      >
        {activity7.steps[1].sonarSteps[2].stepName}{" "}
        {activity7.steps[1].sonarSteps[2].stepDescription}:{" "}
        {activity7.steps[1].sonarSteps[2].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const activity = getActivityAnswer(activity7.id);
            if (!activity || !activity.scenario_1 || !activity.scenario_1.sonar)
              return "";
            return activity.scenario_1.sonar["3"] || "";
          })()}
        </p>

        {isAdmin &&
          !getActivityFeedback(activity7.id, 3) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity7.id, itemId: 3 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity7.id, 3) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity7.id, 3)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity7.id, 3));
                  setActivityFeedbackId({ activityId: activity7.id, itemId: 3 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <p
        className="text-white rounded-3 px-2"
        style={{ background: activity7.steps[1].sonarSteps[3].desBgColor }}
      >
        {activity7.steps[1].sonarSteps[3].stepName}{" "}
        {activity7.steps[1].sonarSteps[3].stepDescription}:{" "}
        {activity7.steps[1].sonarSteps[3].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const activity = getActivityAnswer(activity7.id);
            if (!activity || !activity.scenario_1 || !activity.scenario_1.sonar)
              return "";
            return activity.scenario_1.sonar["4"] || "";
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity7.id, 4) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity7.id, itemId: 4 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity7.id, 4) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity7.id, 4)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity7.id, 4));
                  setActivityFeedbackId({ activityId: activity7.id, itemId: 4 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <p
        className="text-white rounded-3 px-2"
        style={{ background: activity7.steps[1].sonarSteps[4].desBgColor }}
      >
        {activity7.steps[1].sonarSteps[4].stepName}{" "}
        {activity7.steps[1].sonarSteps[4].stepDescription}:{" "}
        {activity7.steps[1].sonarSteps[4].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const activity = getActivityAnswer(activity7.id);
            if (!activity || !activity.scenario_1 || !activity.scenario_1.sonar)
              return "";
            return activity.scenario_1.sonar["5"] || "";
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity7.id, 5) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity7.id, itemId: 5 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity7.id, 5) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity7.id, 5)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity7.id, 5));
                  setActivityFeedbackId({ activityId: activity7.id, itemId: 5 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 2:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity7.steps[2].scenarioTitle}
        </p>
      </div>
      <p
        className="text-white rounded-3 px-2"
        style={{ background: activity7.steps[2].sonarSteps[0].desBgColor }}
      >
        {activity7.steps[2].sonarSteps[0].stepName}{" "}
        {activity7.steps[2].sonarSteps[0].stepDescription}:{" "}
        {activity7.steps[2].sonarSteps[0].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const activity = getActivityAnswer(activity7.id);
            if (!activity || !activity.scenario_2 || !activity.scenario_2.sonar)
              return "";
            return activity.scenario_2.sonar["1"] || "";
          })()}
        </p>

        {isAdmin &&
          !getActivityFeedback(activity7.id, 6) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity7.id, itemId: 6 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity7.id, 6) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity7.id, 6)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity7.id, 6));
                  setActivityFeedbackId({ activityId: activity7.id, itemId: 6 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <p
        className="text-white rounded-3 px-2"
        style={{ background: activity7.steps[2].sonarSteps[1].desBgColor }}
      >
        {activity7.steps[2].sonarSteps[1].stepName}{" "}
        {activity7.steps[2].sonarSteps[1].stepDescription}:{" "}
        {activity7.steps[2].sonarSteps[1].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const activity = getActivityAnswer(activity7.id);
            if (!activity || !activity.scenario_2 || !activity.scenario_2.sonar)
              return "";
            return activity.scenario_2.sonar["2"] || "";
          })()}
        </p>

        {isAdmin &&
          !getActivityFeedback(activity7.id, 7) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity7.id, itemId: 7 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity7.id, 7) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity7.id, 7)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity7.id, 7));
                  setActivityFeedbackId({ activityId: activity7.id, itemId: 7 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <p
        className="text-white rounded-3 px-2"
        style={{ background: activity7.steps[2].sonarSteps[2].desBgColor }}
      >
        {activity7.steps[2].sonarSteps[2].stepName}{" "}
        {activity7.steps[2].sonarSteps[2].stepDescription}:{" "}
        {activity7.steps[2].sonarSteps[2].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const activity = getActivityAnswer(activity7.id);
            if (!activity || !activity.scenario_2 || !activity.scenario_2.sonar)
              return "";
            return activity.scenario_2.sonar["3"] || "";
          })()}
        </p>

        {isAdmin &&
          !getActivityFeedback(activity7.id, 8) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity7.id, itemId: 8 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity7.id, 8) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity7.id, 8)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity7.id, 8));
                  setActivityFeedbackId({ activityId: activity7.id, itemId: 8 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <p
        className="text-white rounded-3 px-2"
        style={{ background: activity7.steps[2].sonarSteps[3].desBgColor }}
      >
        {activity7.steps[2].sonarSteps[3].stepName}{" "}
        {activity7.steps[2].sonarSteps[3].stepDescription}:{" "}
        {activity7.steps[2].sonarSteps[3].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const activity = getActivityAnswer(activity7.id);
            if (!activity || !activity.scenario_2 || !activity.scenario_2.sonar)
              return "";
            return activity.scenario_2.sonar["4"] || "";
          })()}
        </p>

        {isAdmin &&
          !getActivityFeedback(activity7.id, 9) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity7.id, itemId: 9 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity7.id, 9) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity7.id, 9)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity7.id, 9));
                  setActivityFeedbackId({ activityId: activity7.id, itemId: 9 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <p
        className="text-white rounded-3 px-2"
        style={{ background: activity7.steps[2].sonarSteps[4].desBgColor }}
      >
        {activity7.steps[2].sonarSteps[4].stepName}{" "}
        {activity7.steps[2].sonarSteps[4].stepDescription}:{" "}
        {activity7.steps[2].sonarSteps[4].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const activity = getActivityAnswer(activity7.id);
            if (!activity || !activity.scenario_2 || !activity.scenario_2.sonar)
              return "";
            return activity.scenario_2.sonar["5"] || "";
          })()}
        </p>

        {isAdmin &&
          !getActivityFeedback(activity7.id, 10) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity7.id, itemId: 10 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity7.id, 10) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity7.id, 10)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity7.id, 10));
                  setActivityFeedbackId({ activityId: activity7.id, itemId: 10 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 3:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Text Entered by Teacher...
          {activity7.steps[3].scenarioTitle}
        </p>
      </div>
      <p
        className="text-white rounded-3 px-2"
        style={{ background: activity7.steps[3].sonarSteps[0].desBgColor }}
      >
        {activity7.steps[3].sonarSteps[0].stepName}{" "}
        {activity7.steps[3].sonarSteps[0].stepDescription}:{" "}
        {activity7.steps[3].sonarSteps[0].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const activity = getActivityAnswer(activity7.id);
            if (!activity || !activity.scenario_3 || !activity.scenario_3.sonar)
              return "";
            return activity.scenario_3.sonar["1"] || "";
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity7.id, 11) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity7.id, itemId: 11 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity7.id, 11) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity7.id, 11)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity7.id, 11));
                  setActivityFeedbackId({ activityId: activity7.id, itemId: 11 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <p
        className="text-white rounded-3 px-2"
        style={{ background: activity7.steps[3].sonarSteps[1].desBgColor }}
      >
        {activity7.steps[3].sonarSteps[1].stepName}{" "}
        {activity7.steps[3].sonarSteps[1].stepDescription}:{" "}
        {activity7.steps[3].sonarSteps[1].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const activity = getActivityAnswer(activity7.id);
            if (!activity || !activity.scenario_3 || !activity.scenario_3.sonar)
              return "";
            return activity.scenario_3.sonar["2"] || "";
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity7.id, 12) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity7.id, itemId: 12 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity7.id, 12) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity7.id, 12)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity7.id, 12));
                  setActivityFeedbackId({ activityId: activity7.id, itemId: 12 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <p
        className="text-white rounded-3 px-2"
        style={{ background: activity7.steps[3].sonarSteps[2].desBgColor }}
      >
        {activity7.steps[3].sonarSteps[2].stepName}{" "}
        {activity7.steps[3].sonarSteps[2].stepDescription}:{" "}
        {activity7.steps[3].sonarSteps[2].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const activity = getActivityAnswer(activity7.id);
            if (!activity || !activity.scenario_3 || !activity.scenario_3.sonar)
              return "";
            return activity.scenario_3.sonar["3"] || "";
          })()}
        </p>

        {isAdmin &&
          !getActivityFeedback(activity7.id, 13) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity7.id, itemId: 13 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity7.id, 13) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity7.id, 13)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity7.id, 13));
                  setActivityFeedbackId({ activityId: activity7.id, itemId: 13 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <p
        className="text-white rounded-3 px-2"
        style={{ background: activity7.steps[3].sonarSteps[3].desBgColor }}
      >
        {activity7.steps[3].sonarSteps[3].stepName}{" "}
        {activity7.steps[3].sonarSteps[3].stepDescription}:{" "}
        {activity7.steps[3].sonarSteps[3].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const activity = getActivityAnswer(activity7.id);
            if (!activity || !activity.scenario_3 || !activity.scenario_3.sonar)
              return "";
            return activity.scenario_3.sonar["4"] || "";
          })()}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity7.id, 14) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity7.id, itemId: 14 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity7.id, 14) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity7.id, 14)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity7.id, 14));
                  setActivityFeedbackId({ activityId: activity7.id, itemId: 14 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <p
        className="text-white rounded-3 px-2"
        style={{ background: activity7.steps[3].sonarSteps[4].desBgColor }}
      >
        {activity7.steps[3].sonarSteps[4].stepName}{" "}
        {activity7.steps[3].sonarSteps[4].stepDescription}:{" "}
        {activity7.steps[3].sonarSteps[4].question}
      </p>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {(() => {
            const activity = getActivityAnswer(activity7.id);
            if (!activity || !activity.scenario_3 || !activity.scenario_3.sonar)
              return "";
            return activity.scenario_3.sonar["5"] || "";
          })()}
        </p>

        {isAdmin &&
          !getActivityFeedback(activity7.id, 15) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity7.id, itemId: 15 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity7.id, 15) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity7.id, 15)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity7.id, 15));
                  setActivityFeedbackId({ activityId: activity7.id, itemId: 15 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />

      {/* Activity 5 */}
      <p className="bg-blue py-md-3 px-md-5 py-1 px-2 text-white d-inline-block rounded-5 fs-md-4">
        Activity 5
      </p>
      <p
        className="text-gray fs-md-4 week-2-question-text"
        accordion
        style={{ fontSize: 1 + "em" }}
      >
        {activity8.steps[0].instructions.map((text) => (
          <>
            <span>{text}</span>
            <br />
          </>
        ))}
      </p>
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 1:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity8.steps[1].scenarioText}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <div>
          {getRankingResponses(
            getActivityAnswer(activity8.id)?.step_3?.rankings,
            activity8.steps[2]
          ).map((item, idx) => (
            <p key={idx} className="fs-md-4">
              {idx + 1}. {renderAnswerText(item)}
            </p>
          ))}
        </div>

        {isAdmin &&
          !getActivityFeedback(activity8.id, 3) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity8.id, itemId: 3 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity8.id, 3) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity8.id, 3)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity8.id, 3));
                  setActivityFeedbackId({ activityId: activity8.id, itemId: 3 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 2:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity8.steps[3].scenarioText}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <div>
          {getRankingResponses(
            getActivityAnswer(activity8.id)?.step_5?.rankings,
            activity8.steps[4]
          ).map((item, idx) => (
            <p key={idx} className="fs-md-4">
              {idx + 1}. {renderAnswerText(item)}
            </p>
          ))}
        </div>
        {isAdmin &&
          !getActivityFeedback(activity8.id, 5) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity8.id, itemId: 5 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity8.id, 5) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity8.id, 5)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity8.id, 5));
                  setActivityFeedbackId({ activityId: activity8.id, itemId: 5 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 3:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity8.steps[5].scenarioText}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <div>
          {getRankingResponses(
            getActivityAnswer(activity8.id)?.step_7?.rankings,
            activity8.steps[6]
          ).map((item, idx) => (
            <p key={idx} className="fs-md-4">
              {idx + 1}. {renderAnswerText(item)}
            </p>
          ))}
        </div>
        {isAdmin &&
          !getActivityFeedback(activity8.id, 7) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity8.id, itemId: 7 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity8.id, 7) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity8.id, 7)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity8.id, 7));
                  setActivityFeedbackId({ activityId: activity8.id, itemId: 7 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Scenario 4:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity8.steps[7].scenarioText}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <div>
          {getRankingResponses(
            getActivityAnswer(activity8.id)?.step_9?.rankings,
            activity8.steps[8]
          ).map((item, idx) => (
            <p key={idx} className="fs-md-4">
              {idx + 1}. {renderAnswerText(item)}
            </p>
          ))}
        </div>
        {isAdmin &&
          !getActivityFeedback(activity8.id, 9) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity8.id, itemId: 9 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity8.id, 9) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity8.id, 9)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity8.id, 9));
                  setActivityFeedbackId({ activityId: activity8.id, itemId: 9 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Question 1:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity8.steps[9].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        <p className="fs-md-5 flex-grow-1">
          {renderAnswerText(getActivityAnswer(activity8.id)?.step_10?.answer)}
        </p>
        {isAdmin &&
          !getActivityFeedback(activity8.id, 10) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity8.id, itemId: 10 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity8.id, 10) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity8.id, 10)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity8.id, 10));
                  setActivityFeedbackId({ activityId: activity8.id, itemId: 10 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />
      <div className="d-flex gap-3">
        <p
          className="text-blue fs-md-1 week-2-question-text fw-bold"
          style={{ fontSize: 1 + "em" }}
        >
          Question 2:
        </p>
        <p
          className="text-blue fs-md-4 week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          {activity8.steps[10].question}
        </p>
      </div>
      <div className="d-flex gap-3">
        <p
          className="text-gray fs-md-1 text-gray week-2-question-text"
          accordion
          style={{ fontSize: 1 + "em" }}
        >
          Answers:
        </p>
        {renderAnswerText(getActivityAnswer(activity8.id)?.step_11?.answer)}

        {isAdmin &&
          !getActivityFeedback(activity8.id, 11) && (
            <Icon
              onClick={() => {
                setActivityFeedbackId({ activityId: activity8.id, itemId: 11 });
                handleModalOpen();
              }}
              style={{ color: "#D6D6D6" }}
              width={35}
              icon="tabler:message-2"
            />
          )}
      </div>
      {
        // Show this only id theres a feedback
        getActivityFeedback(activity8.id, 11) && (
          <div className="d-flex gap-3">
            <p className="text-bg-secondary rounded-4 px-1 px-md-3 fs-md-5 align-self-start">
              Feedback
            </p>
            <p className="bg-step-active text-gray fs-md-5 flex-grow-1 p-md-2 p-1 rounded">
              {getActivityFeedback(activity8.id, 11)}
            </p>
            {isAdmin && (
              <Icon
                onClick={() => {
                  setModalData(getActivityFeedback(activity8.id, 11));
                  setActivityFeedbackId({ activityId: activity8.id, itemId: 11 });
                  handleModalOpen();
                }}
                style={{ color: "#275DAD" }}
                width={35}
                icon="lucide:edit"
              />
            )}
          </div>
        )
      }
      <hr />

      {/* Assesment 1 */}
      <p className="bg-blue py-1 px-1 py-md-3 px-md-2 text-white d-inline-block rounded-5 fs-md-4">
        Post-Assessment
      </p>
      <hr />
      {(assessments || []).map(({ id, question, options = [], correctOption }, i) => {
        const selectedAnswer = assessmentData?.find(
          (answer) => answer.id === id
        )?.value;
        return (
          <>
            <div className="d-flex gap-3" key={i}>
              <p
                className="text-blue fs-md-1 text-nowrap week-2-question-text fw-bold"
                style={{ fontSize: 1 + "em" }}
              >
                Questions {i + 1}:
              </p>
              <p
                className="text-blue fs-md-4 week-2-question-text"
                style={{ fontSize: 1 + "em" }}
              >
                {question}
              </p>
            </div>
            {(options || []).map((option, index) => {
              const optionKey = Object.keys(option)[0];
              const optionText = option[optionKey];
              const isCorrectOption = correctOption === optionText;
              const isAnswer = selectedAnswer === optionText;
              // console.log(assessmentData,"AssessmentData")

              return (
                <div
                  key={index}
                  className="d-flex gap-md-2 p-0 p-md-1 mb-3 justify-content-between"
                >
                  <div className="d-flex gap-md-2 p-1">
                    <img
                      src={isAnswer ? checkedImage : unCheckedImage}
                      alt={`Option ${optionKey}`}
                      style={{ width: 20, height: 20 }}
                    />
                    <div
                      className="week-2-question-text text-gray"
                      style={{ fontSize: 1 + "em" }}
                    >{`${optionText}. ${option.text}`}</div>
                  </div>
                  {isCorrectOption ? (
                    <p className="d-flex gap-1">
                      {" "}
                      <img
                        src={correct}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />{" "}
                      Correct
                    </p>
                  ) : (
                    <p className="d-flex gap-1">
                      {" "}
                      <img
                        src={wrong}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />
                      Wrong
                    </p>
                  )}
                </div>
              );
            })}
          </>
        );
      })}
      <hr />
      {/* Weekly Report */}
      <div className="bg-button p-3 p-md-5 rounded-4">
        <h2 className="text-white fs-md-1">Weekly Report</h2>
        <div className="d-flex flex-column flex-md-row gap-4">
          <h2 className="text-gray fs-md-1 ratio-1x1 bg-aqua rounded-4 p-3 p-md-5 d-flex justify-content-center border border-6 border-blue">
            {score}%
          </h2>
          <p className="text-white">
            {score < 40
              ? "You’ve taken an important first step in exploring Social and Emotional Learning and Positive Psychology. You’ve started to understand the value of emotional awareness, relationship skills, and teacher wellbeing. However, it seems you may still be building a full grasp of how SEL connects to classroom practice. Revisit the lessons and take time to reflect on how self-awareness and self-management can shape your approach to teaching. Don’t hesitate to ask questions or discuss ideas with your peers; collaboration is one of the best ways to deepen understanding. Every teacher starts somewhere, and your willingness to learn is already a sign of growth"
              : score < 60
                ? "Good effort! You’re beginning to grasp key SEL and Positive Psychology principles such as self-awareness, empathy, and the importance of wellbeing in the classroom. You have a fair understanding of how emotional intelligence supports both teachers and students, but there’s room to strengthen your practical application. Try focusing on mindfulness and emotional regulation strategies in your daily teaching routine. Reflect after each class, ‘How did your emotional state affect your students' responses?’ The more intentional you are, the more confident and balanced you’ll become in integrating SEL principles effectively."
                : score < 80
                  ? "Well done! You’ve shown a strong understanding of SEL and Positive Psychology concepts and are starting to connect them meaningfully to your classroom practice. You recognize how empathy, relationship-building, and emotional regulation influence learning outcomes. To keep improving, aim to apply SEL more consistently, model calm responses to challenges, and build structured moments for reflection or gratitude in your lessons. You’re well on your way to creating a classroom culture rooted in care, connection, and emotional growth."
                  : score < 95
                    ? "Excellent work! You’ve demonstrated a clear understanding of SEL and Positive Psychology competencies and how its principles can transform both teaching and learning. You’ve likely developed effective strategies for fostering empathy, self-regulation, and resilience in your students, and you understand the importance of teacher wellbeing in sustaining those practices. Keep refining your skills by mentoring peers or sharing SEL practices in team meetings. Continue to model emotional intelligence in every interaction, and you will build the kind of classroom where students feel safe, motivated, and valued."
                    : score <= 100
                      ? "Outstanding achievement! You’ve shown exceptional mastery of Social and Emotional Learning. You not only understand the theory but also demonstrate how to live it out in your teaching, balancing self-awareness, empathy, and resilience with skill. Your approach likely fosters deep trust, engagement, and growth in your students. Continue to inspire others by leading discussions on SEL implementation and supporting colleagues who are just beginning their journey. Your dedication to nurturing emotional wellbeing in education sets a powerful example. Keep shining, the ripple effect of your work will last far beyond the classroom."
                      : ""}
          </p>
        </div>
        <Modal
          isOpen={showModal}
          closeModal={handleModalClose}
          data={modalData}
          handleSubmit={submitFeedback}
        />
      </div>
    </>
  );
}

export default Week2;
